export interface IModalConfig {
    Title: KnockoutObservable<string>;
    Content: KnockoutObservable<string>;
    MainButtonText?: KnockoutObservable<string>;
    SecondButtonText?: KnockoutObservable<string>;
}

export class ModalPopup implements IModalConfig {
    [x: string]: any;
    Title: KnockoutObservable<string>;
    Content: KnockoutObservable<string>;
    MainButtonText?: KnockoutObservable<string>;
    SecondButtonText?: KnockoutObservable<string>;

    constructor() {
        this.Title = ko.observable(null);
        this.Content = ko.observable(null);
        this.MainButtonText = ko.observable(null);
        this.SecondButtonText = ko.observable(null);
    }
}

// TODO: Extricate code from DataTarget observable + submit to use pure js functions
export class AlertModal extends ModalPopup {
    public DataTarget?: KnockoutObservable<any> = ko.observable(null);
}